import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Hls from 'hls.js';
import { Collector } from '../models/Collector';
import { getKinesisStreamURL } from '../helpers/AWSKinesis';
import { useUIContext } from '../context/UIContext';

const Root = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    padding-right: 20px;
    overflow-y: auto;
`;

interface CollectorCameraPreviewProps {
  collector: Collector;
}

export const CollectorCameraPreview: FC<CollectorCameraPreviewProps> = ({ collector }) => {
  const { loader, toast } = useUIContext();
  const [videoSrc, setVideoSrc] = useState<string | undefined>('');

  const videoRef = useRef(null);
  const hlsInstance = useRef(null);

  const streamName = collector.hw_serial_num.replaceAll('.', '');

  const fetchStream = async () => {
    loader.showLoader();
    try {
      const url = await getKinesisStreamURL(streamName);
      if (url) setVideoSrc(url);
    } catch (e: any) {
      toast.showToast(e.message, 'ERROR');
    } finally {
      loader.hideLoader();
    }
  };

  useEffect(() => {
    fetchStream().finally(() => undefined);
  }, []);

  useEffect(() => {
    if (videoSrc && videoRef.current) {
      if (hlsInstance.current) {
        // @ts-ignore
        hlsInstance.current.destroy();
      }

      const hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(videoRef.current);
      // @ts-ignore
      hlsInstance.current = hls;

      return () => {
        hls.destroy();
      };
    }
  }, [videoSrc]);
  return (
    <Root>
      <h2>{collector.name}</h2>
      <div style={{ position: 'relative', zIndex: 1, height: '100vh' }}>
        <video ref={videoRef} autoPlay controls style={{ width: '100%' }} />
      </div>
    </Root>
  );
};
